import React, {useEffect, useRef, useState} from 'react';
import axios from 'axios';
import {IoAlertCircle, IoCheckmarkCircle, IoCloudUpload, IoDocument} from 'react-icons/io5';
import * as yup from 'yup';
import "./DevelopmentNewCase.css";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import docIcon from './document.png';
import {useNavigate} from "react-router-dom";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import CaseFilesStatus from "../../../enums/CaseFilesStatus";
import CaseFilesInternal from "../../../enums/CaseFilesInternal";
import CaseFileDeclined from "../../../enums/CaseFileDeclined";
import {MdDeleteForever} from "react-icons/md";
import CaseStatus from "../../../enums/CaseStatus";
import {Dialog, DialogContent, Tooltip} from "@mui/material";
import LoaderCustom from "../../../components/ConfirmationModal/LoaderCustom";
import CaseDetailsForUser from "../../../components/CaseInsideTable/CaseDetailsForUser";
import {FaPen} from "react-icons/fa";


const DevelopmentNewCase = ({geoIds}) => {
    const [fileTypes, setFileTypes] = useState([]);
    const [uploadProgress, setUploadProgress] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [fileErrors, setFileErrors] = useState({});
    const [isUploading, setIsUploading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const fileInputRefs = useRef({});
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("");
    const params = new URLSearchParams(window.location.search);
    const caseId = parseInt(params.get('id'), 10);
    const caseType = parseInt(params.get('caseid'), 10);
    const entity = params.get('entity')
    const parentId = params.get('parentId')
    const explanationEntity = params.get('explanationEntity')
    const navigate = useNavigate();
    const [formattedFileNames, setFormattedFileNames] = useState({});
    const [isNoButtonDisabled, setIsNoButtonDisabled] = useState(false);
    const [modalText, setModalText] = useState("დარწმუნებული ხართ?");
    const [isAccelerationEnabled, setIsAccelerationEnabled] = useState(false);
    const cityIdFromUrl = params.get('municipalityId');
    const [allRequiredUploaded, setAllRequiredUploaded] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingFileTypes, setIsLoadingFileTypes] = useState(true);
    const [isAnyFileUploading, setIsAnyFileUploading] = useState(false);
    const [openCaseDetailsPopup, setOpenCaseDetailsPopup] = useState(false);
    const [caseData, setCaseData] = useState(null);
    const [caseDetails, setCaseDetails] = useState([]);
    const [caseGeography, setCaseGeography] = useState({});
    const [orderDepartment, setOrderDepartment] = useState(null);
    const [caseDataForDocument, setCaseDataForDocument] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false)
    const firstOptions = [
        "საიდენტიფიკაციო ნომერი",
        "ნებართვის მაძიებელი/მფლობელი ორგანიზაცია",
        "ორგანიზაციის იურიდიული მისამართი",
        "ობიექტის მფლობელის საიდენტიფიკაციო კოდი",
        "ობიექტის მფლობელის დასახელება",
        "ობიექტის მფლობელის იურიდიული მისამართი",
    ];

    useEffect(() => {
        console.log(uploadedFiles)
    }, [uploadedFiles]);

    useEffect(() => {
        window.history.pushState(null, '', window.location.href)
        const onPop = () => {
            window.history.pushState(null, '', window.location.href)
            setShowConfirm(true)
        }
        window.addEventListener('popstate', onPop)
        return () => window.removeEventListener('popstate', onPop)
    }, [])

    const handleConfirm = () => {
        setShowConfirm(false)
        navigate(`/dashboard/newcase?id=${caseId}&parentId=${parentId}&entity=${entity}&explanationEntity=${explanationEntity}`)
    }

    const handleClose = () => {
        setShowConfirm(false)
    }



    const fetchPermitType = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeByID?Id=${caseData.permitTypeId}`);
            setOrderDepartment(response.data.data.orderDepartment)
            setCaseDataForDocument(response.data.data)

        } catch (error) {
        }
    };
    useEffect(() => {
        if (caseData) {
            void fetchPermitType();
        }
    }, [caseData]);


    const fetchCaseFiled = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetCaseDetails?CaseId=${caseType}`);
            if (response.data.success) {
                const details = response.data.data.result;
                details.sort((a, b) => {
                    const aHigh = a.inputType === 3 || firstOptions.includes(a.key);
                    const bHigh = b.inputType === 3 || firstOptions.includes(b.key);
                    if (aHigh && !bHigh) return -1;
                    if (!aHigh && bHigh) return 1;
                    return 0;
                });
                setCaseDetails(details);
            }
        } catch (error) {
        }
    };

    useEffect(() => {
        void fetchCaseFiled()
    }, [caseType]);


    const fetchCase = async () => {
        try {

            const caseId = new URLSearchParams(window.location.search).get('caseid');
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetCaseByIdByuser?Id=${caseId}`);
            if (response.data.success && response.data.data.caseNumber) {
                sessionStorage.setItem("caseNumber", response.data.data.caseNumber)
                setCaseData(response.data.data)
                setCaseGeography({
                    region: {id: response.data.data.region, rejected: response.data.data.regionRejected},
                    city: {id: response.data.data.city, rejected: response.data.data.cityRejected},
                    council: {id: response.data.data.council, rejected: response.data.data.councilRejected},
                    populatedArea: {
                        id: response.data.data.populatedArea,
                        rejected: response.data.data.populatedAreaRejected
                    },
                });
            }
            if (response.data.success && response.data.data.status !== 1) {
                navigate(`/dashboard/mycases/casemanager?id=${caseId}`);
                setIsLoading(false)
            } else {
                setIsLoading(false)
            }

        } catch (error) {
            console.error('Failed to fetch case details:', error);
        }
    };
    useEffect(() => {
        void fetchCase();
    }, []);

    const checkAllRequiredUploaded = () => {
        const allUploaded = fileTypes.every(fileType => {
            return !fileType.required || (fileType.required && uploadedFiles[fileType.id]);
        });
        setAllRequiredUploaded(allUploaded);
    };


    const fetchCaseDetails = async () => {
        setIsLoading(true)
        try {
            const caseId = parseInt(params.get('caseid'), 10);
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetCaseByIdByuser?Id=${caseId}`);
            if (response.data.success) {
                setIsAccelerationEnabled(response.data.data.acceleration);
            }
        } catch (error) {
        }
        setIsLoading(false)
    };


    useEffect(() => {
        const fetchData = async () => {
            setIsLoadingFileTypes(true)
            const cityIds = cityIdFromUrl
                .replace(/-/g, '')  // Remove all dashes
                .split(',')         // Split by comma
                .map(id => id.trim())  // Trim any whitespace
                .filter(id => id)   // Remove empty strings (cases with trailing commas)
                .map(id => parseInt(id, 10));

            await fetchCaseDetails()
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllFileTypes`);
                if (response.data.success) {
                    let filteredData = response.data.data.filter(fileType => fileType.caseId === caseId);
                    if (!isAccelerationEnabled) {
                        filteredData = filteredData.filter(fileType => !fileType.isCheck);
                    }
                    filteredData = filteredData.map(fileType => ({
                        ...fileType,
                        required: cityIds.includes(fileType.cityId) ? true : fileType.required,
                    }));
                    filteredData.sort((a, b) => a.sort - b.sort);
                    setFileTypes(filteredData);
                    filteredData.forEach(fileType => {
                        fileInputRefs.current[fileType.id] = React.createRef();
                        setUploadProgress(prevState => ({...prevState, [fileType.id]: 0}));
                        setUploadedFiles(prevState => ({...prevState, [fileType.id]: null}));
                        setFileErrors(prevState => ({...prevState, [fileType.id]: null}));
                    });
                }
            } catch (error) {
            }
            setIsLoadingFileTypes(false)
        };
        void fetchData();
    }, [caseId, isAccelerationEnabled, cityIdFromUrl]);

    const handleBoxClick = (fileTypeId) => {
        fileInputRefs.current[fileTypeId].current.click();
    };

    const handleFileChange = async (fileType, event) => {
        const selectedFile = event.target.files?.[0]
        if (!selectedFile) return

        setIsAnyFileUploading(true)

        let displayName = selectedFile.name
        if (displayName.length > 30) {
            const fileExtension = displayName.substring(displayName.lastIndexOf("."))
            displayName = displayName.substring(0, 27) + "..." + fileExtension
        }
        setFormattedFileNames(prev => ({...prev, [fileType.id]: displayName}))

        const extensionWithDot = "." + selectedFile.name.split(".").pop().toLowerCase()
        const maxSizeBytes = 5000 * 1048576

        if (selectedFile.size > maxSizeBytes) {
            setFileErrors(prev => ({...prev, [fileType.id]: "ფაილის ზომა აღემატება 5000MB."}))
            event.target.value = null
            setIsAnyFileUploading(false)
            return
        }

        if (!fileType.extension.includes(extensionWithDot)) {
            setFileErrors(prev => ({...prev, [fileType.id]: "არასწორი ფორმატი!"}))
            event.target.value = null
            setIsAnyFileUploading(false)
            return
        }

        setFileErrors(prev => ({...prev, [fileType.id]: null}))

        try {
            await deleteExistingFileIfAny(fileType.id)
        } catch {
            event.target.value = null
            setIsAnyFileUploading(false)
            return
        }
        const bigFileLimit = 50 * 1048576
        const isBigFile = selectedFile.size > bigFileLimit

        if (isBigFile) {
            await uploadBigFile(fileType, selectedFile)
        } else {
            await uploadFile(fileType, selectedFile)
        }

        event.target.value = null
    }


    const deleteExistingFileIfAny = async (fileTypeId) => {
        const existingFileEntry = uploadedFiles[fileTypeId]
        if (!existingFileEntry || !existingFileEntry.resultId) return
        try {
            const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteCaseFileByUser`, {
                caseFileId: existingFileEntry.resultId
            })
            if (response.data?.success) {
                setUploadedFiles(prev => ({...prev, [fileTypeId]: null}))
                setUploadProgress(prev => ({...prev, [fileTypeId]: 0}))
                setFileErrors(prev => ({...prev, [fileTypeId]: null}))
                setFormattedFileNames(prev => ({...prev, [fileTypeId]: ""}))
                if (fileInputRefs.current[fileTypeId]?.current) {
                    fileInputRefs.current[fileTypeId].current.value = ""
                }
                checkAllRequiredUploaded()
            } else {
                setAlertMessage(response.data?.errorMessage || "Failed to delete the previous file.")
                setAlertType("error")
                setShowAlert(true)
                new Error("Previous file deletion failed")
            }
        } catch (e) {
            setAlertMessage("Error deleting previous file: " + (e?.message || "Unknown error"))
            setAlertType("error")
            setShowAlert(true)
            throw e
        }
    }


    const uploadFile = async (fileType, file) => {

        let fileSizeMB = Math.round(file.size / (1024 * 1024));
        fileSizeMB = fileSizeMB < 1 ? 1 : fileSizeMB; // Set minimum to 1 MB


        setIsUploading(true); // Disable other uploads

        const fileBase64 = await toBase64(file);
        const fileData = {
            caseID: caseType,
            name: fileType.title,
            ext: file.name.split('.').pop(),
            file: fileBase64,
            mainInfo: "",
            additionalInfo: "",
            shared: true,
            blank: false,
            documentType: 0,
            internal: CaseFilesInternal.No,
            status: CaseFilesStatus.Sent,
            decline: CaseFileDeclined.No,
            fileTypeId: fileType.id,
            declinedInternalStatus: 0,
            registeryDocumentType: fileType.registeryDocumentType,
            inActiveIsInspectionSertificate: fileType.isinspectionSertificate


        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, fileData, {
                onUploadProgress: progressEvent => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(prevState => ({...prevState, [fileType.id]: percentCompleted}));
                }
            });

            if (response.data.success === true && response.data.resultId !== undefined) {
                setUploadedFiles(prevState => ({
                    ...prevState,
                    [fileType.id]: {
                        file: file,
                        resultId: response.data.resultId
                    }
                }));
                setUploadProgress(prevState => ({...prevState, [fileType.id]: 100}));
            } else {
                setAlertMessage("დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!");
                setAlertType("error");
                setShowAlert(true);
                setUploadProgress(prevState => ({...prevState, [fileType.id]: 0}));
            }
        } catch (error) {
            // Handle error during the request
            setAlertMessage("Upload failed: " + error.message);
            setAlertType("error");
            setShowAlert(true);
            setUploadProgress(prevState => ({...prevState, [fileType.id]: 0}));
        } finally {
            setIsUploading(false);
            setIsUploading(false); // Re-enable uploads after completion
            const stillUploading = Object.values(uploadProgress).some(progress => progress > 0 && progress < 100);
            setIsAnyFileUploading(stillUploading);
        }
    };


    const uploadBigFile = async (fileType, file) => {
        let fileSizeMB = Math.round(file.size / (1024 * 1024));

        setIsUploading(true);

        const metadata = {
            caseID: caseType,
            name: fileType.title,
            ext: file.name.split(".").pop(),
            mainInfo: "",
            additionalInfo: "",
            shared: true,
            blank: false,
            documentType: 0,
            internal: CaseFilesInternal.No,
            status: CaseFilesStatus.Sent,
            decline: CaseFileDeclined.No,
            fileTypeId: fileType.id,
            declinedInternalStatus: 0,
            registeryDocumentType: fileType.registeryDocumentType,
            inActiveIsInspectionSertificate: fileType.isinspectionSertificate
        };

        const formData = new FormData();
        formData.append("file", file);
        formData.append("metadata", JSON.stringify(metadata));

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/UploadCaseFileLarge`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    onUploadProgress: progressEvent => {
                        const percentCompleted = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        setUploadProgress(previousState => ({
                            ...previousState,
                            [fileType.id]: percentCompleted
                        }));
                    }
                }
            );

            if (response.data.success === true && response.data.resultId !== undefined) {
                setUploadedFiles(previousState => ({
                    ...previousState,
                    [fileType.id]: {
                        file: file,
                        resultId: response.data.resultId
                    }
                }));
                setUploadProgress(previousState => ({
                    ...previousState,
                    [fileType.id]: 100
                }));
            } else {
                setAlertMessage("დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!");
                setAlertType("error");
                setShowAlert(true);
                setUploadProgress(previousState => ({
                    ...previousState,
                    [fileType.id]: 0
                }));
            }
        } catch (error) {
            setAlertMessage("Upload failed: " + error.message);
            setAlertType("error");
            setShowAlert(true);
            setUploadProgress(previousState => ({
                ...previousState,
                [fileType.id]: 0
            }));
        } finally {
            setIsUploading(false);
            const stillUploading = Object.values(uploadProgress).some(
                progress => progress > 0 && progress < 100
            );
            setIsAnyFileUploading(stillUploading);
        }
    };


    const handleDeleteFile = async (fileType) => {
        const fileDetails = uploadedFiles[fileType.id];
        if (fileDetails && fileDetails.resultId) {
            try {
                const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteCaseFileByUser`, {
                    caseFileId: fileDetails.resultId
                });

                if (response.data.success) {
                    setUploadedFiles(prevState => ({...prevState, [fileType.id]: null}));
                    setUploadProgress(prevState => ({...prevState, [fileType.id]: 0}));
                    setFileErrors(prevState => ({...prevState, [fileType.id]: null}));
                    setFormattedFileNames(prevState => ({...prevState, [fileType.id]: ''}));
                    checkAllRequiredUploaded();


                    // Reset the input reference to allow re-upload of the same file
                    if (fileInputRefs.current[fileType.id]) {
                        fileInputRefs.current[fileType.id].current.value = '';
                    }
                } else {
                    setAlertMessage(response.data.errorMessage || "Failed to delete the file.");
                    setAlertType("error");
                    setShowAlert(true);
                }
            } catch (error) {
                setAlertMessage("Error deleting file: " + error.message);
                setAlertType("error");
                setShowAlert(true);
            }
        }
    };


    const handleViewDocument = (fileType) => {
        const fileDetails = uploadedFiles[fileType.id];

        if (fileDetails && fileDetails.file) {
            const fileURL = URL.createObjectURL(fileDetails.file);  // Ensure you're accessing a File object
            window.open(fileURL, '_blank');
            URL.revokeObjectURL(fileURL);
        }
    };


    const validateUploads = async () => {
        let schema = yup.object().shape({});
        fileTypes.forEach(fileType => {
            if (fileType.required) {
                schema = schema.shape({
                    [fileType.id]: yup.mixed().required(`დოკუმენტი სავალდებულოა!`)
                });
            }
        });

        try {
            await schema.validate(uploadedFiles, {abortEarly: false});
            return true;
        } catch (err) {
            err.inner.forEach(error => {
                setFileErrors(prev => ({...prev, [error.path]: error.message}));
            });
            return false;
        }
    };


    const handleCloseCaseDetails = () => {
        setOpenCaseDetailsPopup(false);
    };

    const handleClickOpenCaseDetails = () => {
        setOpenCaseDetailsPopup(true);
    };

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const base64String = reader.result.split(',')[1];
            resolve(base64String);
        };
        reader.onerror = error => reject(error);
    });

    const performUpload = async () => {
        setIsUploading(true);
        setIsNoButtonDisabled(true);
        try {
            await updateCaseStatus();
            await sendNotification();
            setAlertMessage("Upload successful!");
            setAlertType("success");
            if (window.innerWidth < 768) {
                navigate("/success", {state: {pageName: 'activecases'}});
            } else {
                navigate("/dashboard/activecases", {state: {pageName: 'activecases'}})
            }
        } catch (error) {
            console.error("Failed to perform upload:", error);
            setAlertMessage("Upload failed!");
            setAlertType("error");
        }
    };


    const updateCaseStatus = async () => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseStatusByUser`, {
                caseId: caseType,
                caseStatus: CaseStatus.Sent.id,
                finished: false
            });

        } catch (error) {
        }
    };

    const sendNotification = async () => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CreateCaseNotificationforHeadOfAgency`, {
                caseId: caseType,
                caseStatus: CaseStatus.Sent.id,
                action: 1
            });

        } catch (error) {
        }
    };


    useEffect(() => {
        checkAllRequiredUploaded();
    }, [fileTypes, uploadedFiles]);

    const refreshData = () => {
        void fetchCaseFiled()
        void fetchPermitType()
        void fetchCase()
        void fetchCaseDetails()
        setOpenCaseDetailsPopup(false)
    };

    const handleUploadFiles = async () => {
        if (!await validateUploads()) {
            return;
        }
        setIsModalOpen(true);
    };

    return (
        <div>

            {isLoading || isLoadingFileTypes ? (
                <LoaderCustom/>

            ) : (
                <div>
                    <div className="file-upload-page">

                        <div className="top-left-tooltip">

                            <>
                                {!openCaseDetailsPopup && caseData && caseDetails.length > 0 && caseDataForDocument && caseGeography.length !== 0 && orderDepartment && (
                                    <button
                                        style={{marginTop: 10}}
                                        onClick={handleClickOpenCaseDetails}
                                        className="upload-button"
                                    >
                                        <FaPen size="24px" className="upload-icon"/>
                                        შევსებლი ინფორმაციის რედაქტირება
                                    </button>
                                )}

                                <Dialog
                                    fullWidth={true}
                                    maxWidth="xl"
                                    style={{
                                        zIndex: 4,
                                        width: '100%',
                                        maxHeight: '100vh'
                                    }}
                                    open={openCaseDetailsPopup}
                                    onClose={handleCloseCaseDetails}
                                >
                                    <DialogContent style={{height: 'calc(100vh - 64px)'}}>
                                        <CaseDetailsForUser
                                            role={"USER"}
                                            caseFinished={false}
                                            caseInfo={caseData}
                                            permitTypeId={caseData.permitTypeId}
                                            caseMustBeActive={false}
                                            caseDetails={caseDetails}
                                            onDetailChange={refreshData}
                                            caseFiles={[]}
                                            onFileAdded={refreshData}
                                            onCaseStatusChange={refreshData}
                                            isButtonVisible={false}
                                            caseGeography={caseGeography}
                                            isObjectInRegistery={true}
                                            geoIds={geoIds}
                                            caseParentId={caseData.caseParentId}
                                            isCaseParentIdRejected={caseData.isRejectedCaseParentId}
                                            onCaseParentIdRejection={refreshData}
                                            caseData={caseDataForDocument}
                                            users={[]}
                                            isAddressRejected={caseData.addressDeclinedStatus}
                                            isCadastralCodeRejected={caseData.cadastralCodeDenclinedStatus}
                                            orderDepartment={orderDepartment}
                                            isPopup={false}
                                        />
                                    </DialogContent>
                                </Dialog>
                            </>

                        </div>

                        <div className="top-right-tooltip">
                            {!openCaseDetailsPopup && (
                                <Tooltip
                                    title={(isUploading || !allRequiredUploaded) ? "განაცხადის რეგისტრაცისთვის ატვირთეთ ყველა სავალდებულო დოკუმენტი!" : ""}
                                >

                                    <button
                                        onClick={handleUploadFiles}
                                        disabled={isLoading || isUploading || !allRequiredUploaded || isLoadingFileTypes || isAnyFileUploading} // Add isAnyFileUploading to the conditions
                                        className="upload-button"
                                    >
                                        <IoCloudUpload size="24px" className="upload-icon"/>
                                        განაცხადის გაგზავნა
                                    </button>


                                </Tooltip>
                            )}

                        </div>

                        <div className="file-upload-container">
                            {fileTypes.map((fileType, index) => (
                                <div key={index}>
                                    <div key={fileType.id}
                                         className={`file-box ${uploadProgress[fileType.id] === 100 ? 'upload-complete' : ''}`}
                                         onClick={() => handleBoxClick(fileType.id)}>
                                        <img src={docIcon} alt="Document" className="document-icon"/>
                                        <div className="file-content">
                                            <div className="file-top">
                                                <div>
                                                    <h4 className={"documnet-title"}>{fileType.title}</h4>
                                                    <div
                                                        className={"documnet-title"}>გაფართოება: {fileType.extension}</div>
                                                    <div className={"documnet-title"}>მაქსიმალური
                                                        ზომა: 5000MB.
                                                    </div>
                                                    <div
                                                        className={"documnet-title"}>{formattedFileNames[fileType.id]}
                                                    </div>
                                                </div>
                                                {fileType.required && uploadProgress[fileType.id] !== 100 && (
                                                    <div className="icon-container">
                                                        <IoAlertCircle color="red" fontSize={"24px"}/>
                                                    </div>
                                                )}
                                                {uploadProgress[fileType.id] === 100 && uploadedFiles[fileType.id]?.resultId && (
                                                    <div className="icon-container">
                                                        <IoCheckmarkCircle size="24px" color="green"/>
                                                    </div>
                                                )}
                                            </div>
                                            {fileErrors[fileType.id] &&
                                                <div className="error-message-doc">{fileErrors[fileType.id]}</div>}


                                            <input
                                                type="file"
                                                ref={fileInputRefs.current[fileType.id]}
                                                style={{display: 'none'}}
                                                accept={`${fileType.extension}`}
                                                onChange={(e) => handleFileChange(fileType, e)}
                                            />
                                        </div>
                                    </div>
                                    {uploadProgress[fileType.id] > 0 &&
                                        uploadProgress[fileType.id] < 101 &&
                                        !uploadedFiles[fileType.id]?.resultId  && (
                                            <div className="progress-bar-container">
                                                <div
                                                    className="progress-bar-fill"
                                                    style={{ width: `${uploadProgress[fileType.id]}%` }}
                                                ></div>

                                                <div className="progress-bar-text">
                                                    {Math.min(uploadProgress[fileType.id], 99)}%
                                                </div>
                                            </div>
                                        )}



                                    {uploadProgress[fileType.id] === 100 &&
                                        uploadedFiles[fileType.id]?.resultId && (
                                            <div className="documnet-actions-contaioner">
                                                <button
                                                    className="view-doc-button"
                                                    onClick={() => handleViewDocument(fileType)}
                                                >
                                                    <IoDocument/> ნახვა
                                                </button>

                                                <button
                                                    className="view-del-button"
                                                    onClick={() => handleDeleteFile(fileType)}
                                                >
                                                    <MdDeleteForever/> წაშლა
                                                </button>
                                            </div>
                                        )}

                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            )}
            <div>
                <ConfirmationModal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    onConfirm={performUpload}
                    isNoButtonDisabled={isNoButtonDisabled}
                    modalText={modalText}
                />
                <ConfirmationModal
                    isOpen={showConfirm}
                    onRequestClose={handleClose}
                    onConfirm={handleConfirm}
                    modalText="უკან დაბრუნების შემთხვევაში განაცხადის შევსება თავიდან დაიწყება და შეყვანილი ინფორმაცია წაიშლება. შეცვლისთვის გამოიყენეთ ღილაკი „შევსებული ინფორმაციის რედაქტირება“. დარწმუნებული ხართ, რომ გსურთ დაბრუნება?"
                />
                {showAlert && (
                    <CustomAlert
                        message={alertMessage}
                        type={alertType}
                        onClose={() => setShowAlert(false)}
                    />
                )}
            </div>
        </div>
    );
};

export default DevelopmentNewCase;
